import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import apiCall from "../../API/API";
import { useLocation, useNavigate  } from "react-router-dom";

const UpdateRole = () => {
  const location = useLocation();
  const { role } = location.state || {};

  const [route, setRoute] = useState(role?.route);
  const [routeFor, setRouteFor] = useState(role?.routeFor);
  const [selectRole, setSelectRole] = useState(role?.roles || []);
  const [description, setDescription] = useState(role?.description || '');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); 

  const handleSubmit = async () => {                                
    setLoading(true);
    try {
      const body = {
        route,
        routeFor,
        role: selectRole,
      };
      const response = await apiCall("POST", "/update-route-role", body);
      if (response?.data?.success) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.error?.message);
      }
    } catch (e) {
      toast.error(e?.response?.data?.message || "Failed to update role.");
    }finally {
      setLoading(false); // Set loading to false once the response is received
    }
  };

  const handleRoleChange = (selectedRole) => {
    setSelectRole((prevRoles) => {
      const updatedRoles = Array.isArray(prevRoles) ? prevRoles : [];
      return updatedRoles.includes(selectedRole)
        ? updatedRoles.filter((role) => role !== selectedRole)
        : [...updatedRoles, selectedRole];
    });
  };

  return (
    <Container>
      <section id="bankForm">
        <div className="d-flex justify-content-center">
          <h2>Update Route Role</h2>
        </div>
        <section id="formContent">
          <div className="form">
            <Row>
              <Col lg={6} style={{ margin: "auto" }}>
                <form onSubmit={(e) => e.preventDefault()} className="registerForm">
                  <div>
                    <label>Route</label>
                    <input type="text" value={route} disabled />
                  </div>
                  <div>
                    <label>Route For</label>
                    <input type="text" value={routeFor} disabled />
                  </div>
                  <div>
                    <label>Description</label>
                    <input type="text" value={description} disabled />
                  </div>
                  <div>
                    <label>Role</label>
                    <div className="d-flex justify-content-between flex-wrap">
                        {(routeFor === "user" ? ["public", "user"] : ["admin", "manager"]).map(
                          (roleName) => (
                            <div
                              key={roleName}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "2px",
                                marginBottom: "10px",
                                width: "45%",
                              }}
                            >
                              <input
                                type="checkbox"
                                id={roleName}
                                value={roleName}
                                checked={selectRole?.includes(roleName)}
                                onChange={() => handleRoleChange(roleName)}
                              />
                              <label htmlFor={roleName} style={{ marginLeft: "5px" }}>
                                {roleName.charAt(0).toUpperCase() + roleName.slice(1)}
                              </label>
                            </div>
                          )
                        )}
                      </div>
                  </div>
                  <Button variant="secondary" className="save" onClick={() => navigate(-1)}>
                    Cancel
                  </Button>
                  {/* <Button onClick={handleSubmit} className="save">
                    Update
                  </Button> */}
                  <Button onClick={handleSubmit} className="save" disabled={loading}>
                    {loading ? (
                      <div className="d-flex align-items-center">
                        <span>Updating...</span>
                      </div>
                    ) : (
                      "Update"
                    )}
                  </Button>
                </form>
              </Col>
            </Row>
          </div>
        </section>
      </section>
    </Container>
  );
};

export default UpdateRole;
